import { render, staticRenderFns } from "./Agrofag.vue?vue&type=template&id=44fda4ce"
import script from "./Agrofag.vue?vue&type=script&lang=js"
export * from "./Agrofag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports